import { render, staticRenderFns } from "./TeamCompany.vue?vue&type=template&id=086653ce&lang=pug&"
import script from "./TeamCompany.vue?vue&type=script&lang=ts&"
export * from "./TeamCompany.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports